import { render } from "./DayViewWorkAreaGridGroup.vue?vue&type=template&id=4e83a399"
import script from "./DayViewWorkAreaGridGroup.vue?vue&type=script&lang=ts"
export * from "./DayViewWorkAreaGridGroup.vue?vue&type=script&lang=ts"
script.render = render

export default script